import { GroupMembership, Recognition } from '@aslanpay/portal-common-lib';
import { StrictGroupWithPot } from 'app/hooks/useGroupsWithPot/types';

export type ApprovalsTab = 'escalations' | 'pendingApprovals';

export const ESCALATION_DAYS_THRESHOLD = 3;

export interface RecognitionWithPot extends Recognition {
  groupWithPot?: StrictGroupWithPot;
  potManagers: GroupMembership[];
}
